/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiAbbreviatedShow } from './AbbreviatedShow';
import { ApiAbbreviatedTalent } from './AbbreviatedTalent';
import { ApiVOD } from './VOD';
import { ApiPodcast } from './Podcast';

export interface AbbreviatedProductionRequest {

    id?: string;

    /**
     * Date of the production
     */
    date?: string;

    /**
     * Name of the episode
     */
    title?: string;

    /**
     * Internal tracking name for this production
     */
    internal_name?: string;

    /**
     * Date of the production
     */
    date_simple?: string;

    /**
     * The show for this production (if available)
     */
    show?: ApiAbbreviatedShow;

    hosts?: ApiAbbreviatedTalent[];

    guests?: ApiAbbreviatedTalent[];

    full_length_vods?: ApiVOD[];

    full_length_podcasts?: ApiPodcast[];

    vod_clips?: ApiVOD[];

    audio_clips?: ApiPodcast[];

    /**
     * Featured clip in this production
     */
    featured_clip?: ApiVOD;

    /**
     * URL of the primary landscape thumbanil for this VOD
     */
    thumbnail_landscape1?: string;

    /**
     * Pin expiration date for clips
     */
    pin_on_clips?: string;

    /**
     * Pin expiration date for episodes
     */
    pin_on_episodes?: string;

    /**
     * Pin expiration date for podcasts
     */
    pin_on_podcasts?: string;

    /**
     * Pin expiration date for candidates
     */
    pin_on_candidates?: string;

}

@Model('AbbreviatedProduction')
export class ApiAbbreviatedProduction extends BaseModel implements AbbreviatedProductionRequest {

    
    
    id: string;

    /**
     * Date of the production
     */
    
    
    date: string;

    /**
     * Name of the episode
     */
    
    
    title: string;

    /**
     * Internal tracking name for this production
     */
    
    
    internal_name: string;

    /**
     * Date of the production
     */
    
    
    date_simple: string;

    /**
     * The show for this production (if available)
     */
    @Type('ApiAbbreviatedShow')
    @Expand()
    show: ApiAbbreviatedShow;

    @Type('ApiAbbreviatedTalent')
    @Expand()
    hosts: ApiAbbreviatedTalent[];

    @Type('ApiAbbreviatedTalent')
    @Expand()
    guests: ApiAbbreviatedTalent[];

    @Type('ApiVOD')
    @Expand()
    full_length_vods: ApiVOD[];

    @Type('ApiPodcast')
    @Expand()
    full_length_podcasts: ApiPodcast[];

    @Type('ApiVOD')
    @Expand()
    vod_clips: ApiVOD[];

    @Type('ApiPodcast')
    @Expand()
    audio_clips: ApiPodcast[];

    /**
     * Featured clip in this production
     */
    @Type('ApiVOD')
    @Expand()
    featured_clip: ApiVOD;

    /**
     * URL of the primary landscape thumbanil for this VOD
     */
    
    
    thumbnail_landscape1: string;

    /**
     * Pin expiration date for clips
     */
    
    
    pin_on_clips: string;

    /**
     * Pin expiration date for episodes
     */
    
    
    pin_on_episodes: string;

    /**
     * Pin expiration date for podcasts
     */
    
    
    pin_on_podcasts: string;

    /**
     * Pin expiration date for candidates
     */
    
    
    pin_on_candidates: string;

}
